export const prospectAudit = {
  title: 'Auditorías de prospectos',
  subtitle: 'Auditorías generadas automáticamente por el formulario de Supabase.',
  empty: 'Aún no hay envíos de prospectos.',
  loading: 'Cargando prospectos…',
  searchPlaceholder: 'Buscar por email o URL',
  searchLabel: 'Buscar envíos de prospectos',
  columns: {
    email: 'Email',
    url: 'URL',
    referralSource: 'Origen',
    status: 'Estado',
    submittedAt: 'Recibido',
    auditStatus: 'Estado auditoría',
  },
  status: {
    received: 'En cola',
    started: 'Despachada',
    failed: 'Falló',
    deduplicated: 'Duplicado',
  },
  auditStatus: {
    pending: 'Pendiente',
    crawling: 'Crawleando',
    processing: 'Procesando',
    analyzing_geo: 'Analizando GEO',
    analyzing_presence: 'Analizando presencia',
    awaiting_confirmation: 'Esperando confirmación',
    analyzing_presence_targeted: 'Analizando competidores',
    generating_report: 'Generando reporte',
    completed: 'Completada',
    failed: 'Falló',
  },
  pagination: {
    prev: 'Página anterior',
    next: 'Página siguiente',
    pageOf: 'Página {{page}} de {{total}}',
  },
} as const
